"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feedback = void 0;
var Feedback;
(function (Feedback) {
    Feedback["Error"] = "+error";
    Feedback["Warning"] = "+warning";
    Feedback["Success"] = "+success";
})(Feedback = exports.Feedback || (exports.Feedback = {}));
//# sourceMappingURL=Feedback.js.map